
import React, { useState, useEffect } from 'react'
import Box from './Box'

/**
 * Button component.
 *
 * Themes:
 * 
 * - default
 * - primary
 * - danger
 * - minimal
 *
 */

export default function Button({ icon: Icon, iconBefore: IconBefore, iconAfter: IconAfter, theme = 'default', size = 'normal', is = 'button', children, active, hover, disabled, pending, delay = 300, ...props }) {
  const classes = ['Button', theme, active && 'active', hover && 'hover']
  const [isPending, setPending] = useState(false)
  const isDisabled = disabled || isPending

  useEffect(_ => {
    if (!pending) return setPending(false)

    const id = setTimeout(_ => {
      setPending(true)
    }, delay)

    return _ => {
      clearTimeout(id)
    }
  }, [pending])

  if (Icon) classes.push('has-icon')
  if (IconBefore) classes.push('has-icon-before')
  if (IconAfter) classes.push('has-icon-after')
  if (size != 'normal') classes.push(size)

  return <Box is={is} classes={classes} disabled={isDisabled} pending={isPending} {...props}>
    { Icon && <Icon className="icon" /> }
    { IconBefore && <IconBefore className="icon" /> }
    {children}
    { IconAfter && <IconAfter className="icon" /> }
  </Box>
}